import { CircularProgress } from '@material-ui/core';
import * as React from 'react';

interface Props {
  show: boolean;
}

export default class PendingIcon extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  public render() {
    const { show } = this.props;
    return show ? <CircularProgress variant="indeterminate" /> : null;
  }
}
